import Vue from 'vue';
import VueAwesomeSwiper from 'vue-awesome-swiper';

// import style (<= Swiper 5.x)
import 'swiper/css/swiper.css';

// overwrites
import './swiper.less';

Vue.use(VueAwesomeSwiper);
